import { useEffect, useState } from "react";
import BASEURL from "../../../Utils/Baseurl";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  ButtonGroup,
  Icon,
  ToggleButton,
  ToggleButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Chip,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import Swal from "sweetalert2";
import "./File.css";
import axios from "axios";
import IosShareIcon from "@mui/icons-material/IosShare";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { useLoading } from "../../../../context/loading";
import request, { gql } from "graphql-request";
import MaterialInput from "../../../../components/MaterialInput";
import useBranchAccess from "../../../../hooks/useBranchAccess";

const AddPayroll = () => {
  const { isBranchAdmin, userBranch } = useBranchAccess();
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const statedata = location?.state?.data;
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [employee, setEmplyoee] = useState({});
  const [employeeSalaryList, setEmployeeSalaryList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [payrollRunType, setPayrollRunType] = useState("category");
  const [preRunData, setPreRunData] = useState([]);
  const [preRunView, setPreRunView] = useState(false);

  // Phase 1: Edit dialog states
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [editFields, setEditFields] = useState({
    salaryDays: "",
    absentDays: "",
    mealsDays: "",
    shiftPaiseDays: "",
    otHours: "",
    editRemarks: "",
  });

  // Phase 2: Regularization suggestion dialog states
  const [regDialogOpen, setRegDialogOpen] = useState(false);
  const [regDates, setRegDates] = useState([]);
  const [regAction, setRegAction] = useState("");
  const [selectedRegDates, setSelectedRegDates] = useState([]);
  const [salaryDaysDiff, setSalaryDaysDiff] = useState(0);
  const [regEmployeeId, setRegEmployeeId] = useState(null);

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();

  const startYear = 2000;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }
  const yearOptions = years.map((year) => ({
    value: year,
    label: year.toString(),
  }));

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear.toString(),
  });
  const [selectedMonth, setSelectedMonth] = useState({
    value: currentMonth + 1,
    label: monthNames[currentMonth],
  });

  const currentMonths = new Date().getMonth();

  const monthOptions = () => {
    let month;
    if (selectedYear?.value) {
      if (currentYear == selectedYear?.value) {
        month = monthNames.slice(0, currentMonths + 1).map((month, index) => ({
          value: index + 1,
          label: month,
        }));
      } else {
        month = monthNames.map((month, index) => ({
          value: index + 1,
          label: month,
        }));
      }
    } else {
      month = monthNames.map((month, index) => ({
        value: index + 1,
        label: month,
      }));
    }
    return month;
  };

  //Excel handle

  const handleExportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(EarningListTable.rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Earnings Report");

    // Convert to binary and save
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(data, "EarningsReport.xlsx");
  };

  // handle Table

  const EarningListTable = {
    columns: [
      { field: "id", headerName: "S No", width: 80, sortable: true },
      { field: "action", headerName: "Pay Slip", width: 130, sortable: true },
      {
        field: "employeeId",
        headerName: "Employee ID",
        width: 130,
        sortable: true,
      },
      {
        field: "employeeName",
        headerName: "Employee Name",
        width: 130,
        sortable: true,
      },
      {
        field: "accountNumber",
        headerName: "Account Number",
        width: 130,
        sortable: true,
      },
      {
        field: "employeeCategory",
        headerName: "Employee Category",
        width: 150,
        sortable: true,
      },
      {
        field: "esiNumber",
        headerName: "ESI Number",
        width: 130,
        sortable: true,
      },
      {
        field: "pfNumber",
        headerName: "PF Number",
        width: 130,
        sortable: true,
      },
      {
        field: "monthDays",
        headerName: "Month Days",
        width: 130,
        sortable: true,
      },
      {
        field: "salaryDays",
        headerName: "Salary Days",
        width: 130,
        sortable: true,
      },
      {
        field: "absentDays",
        headerName: "Absent Days",
        width: 130,
        sortable: true,
      },
      {
        field: "basicPay",
        headerName: "Basic Pay",
        width: 130,
        sortable: true,
      },
      {
        field: "daAllowance",
        headerName: "DA Allowance",
        width: 130,
        sortable: true,
      },

      {
        field: "hraAmount",
        headerName: "HRA Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "attendanceAllowance",
        headerName: "Attendance Allowance",
        width: 170,
        sortable: true,
      },
      {
        field: "mealsDays",
        headerName: "Meals Days",
        width: 130,
        sortable: true,
      },
      {
        field: "shiftPaiseDays",
        headerName: "Shift Paise Days",
        width: 140,
        sortable: true,
      },
      { field: "otHours", headerName: "OT Hours", width: 130, sortable: true },
      {
        field: "earnedBasic",
        headerName: "Earned Basic",
        width: 130,
        sortable: true,
      },
      {
        field: "earnedDA",
        headerName: "Earned DA",
        width: 130,
        sortable: true,
      },
      {
        field: "lopAmount",
        headerName: "LOP Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "otAmount",
        headerName: "OT Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "shiftPaiseAmount",
        headerName: "Shift Paise Amount",
        width: 150,
        sortable: true,
      },
      { field: "busFare", headerName: "Bus Fare", width: 130, sortable: true },
      {
        field: "grossPay",
        headerName: "Gross Pay",
        width: 130,
        sortable: true,
      },
      {
        field: "esiAmount",
        headerName: "ESI Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "pfAmount",
        headerName: "PF Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "totalAmount",
        headerName: "Total Amount",
        width: 130,
        sortable: true,
      },
      {
        field: "advanceAmount",
        headerName: "Advance Amount",
        width: 130,
        sortable: true,
      },
      { field: "netPay", headerName: "Net Pay", width: 130, sortable: true },
    ],
    rows: employeeSalaryList?.map((addItem, ind) => ({
      id: addItem?.id,
      employeeId: addItem?.employee?.empid,
      employeeName:
        addItem?.employee?.firstName + " " + addItem?.employee?.lastName,
      accountNumber: addItem?.employee?.bankDetails?.accountNumber,
      employeeCategory: addItem?.employee?.category,
      esiNumber: addItem?.employee?.esicNumber,
      pfNumber: addItem?.employee?.uanNumber,
      monthDays: addItem?.monthDays,
      salaryDays: addItem?.salaryDays,
      absentDays: addItem?.absentDays,
      basicPay: addItem?.basicAmount,
      daAllowance: addItem?.daAmount,
      hraAmount: addItem?.hraAmount,
      attendanceAllowance: addItem?.attendanceAllowance,
      mealsDays: addItem?.mealsDays,
      shiftPaiseDays: addItem?.shiftPaiseDays,
      otHours: addItem?.otHours,
      earnedBasic: addItem?.earnedBasic,
      earnedDA: addItem?.earnedDa,
      lopAmount: addItem?.lopAmount,
      otAmount: addItem?.otAmount,
      shiftPaiseAmount: addItem?.shiftPaiseAmount,
      busFare: addItem?.busFare,
      grossPay: addItem?.grossPay,
      esiAmount: addItem?.esiAmount,
      pfAmount: addItem?.pfAmount,
      totalAmount: addItem?.totalAmount,
      advanceAmount: addItem?.advanceAmount,
      netPay: addItem?.netPay,
      action: (
        <>
          <button
            onClick={() => navigate("/payroll/payslip", { state: addItem })}
          >
            Download
          </button>
        </>
      ),
    })),
  };

  const employeeAndId = gql`
    query GetPayrollEmployees($payrollMonth: Int, $payrollYear: Int, $branches: [String]) {
      allUsersDetail(payrollMonth: $payrollMonth, payrollYear: $payrollYear, branches: $branches) {
        id
        firstName
        lastName
        empid
        email
        category
      }
    }
  `;

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        // Pass selected month/year so resigned employees with Last_working_day
        // in that month also appear in the dropdown for individual payroll runs
        const resp = await request(BASEURL, employeeAndId, {
          payrollMonth: selectedMonth?.value || null,
          payrollYear: selectedYear?.value || null,
          branches: isBranchAdmin && userBranch ? [userBranch] : [],
        });

        if (resp?.allUsersDetail) {
          const formattedEmployees = resp.allUsersDetail.map((user) => ({
            value: user.id,
            label: user.firstName+" "+user.lastName,
            empid: user.empid,
            category: user.category,
          }));

          setEmployeeOptions(formattedEmployees);
        }
      } catch (error) {
        console.error("Error fetching Employee Details", error);
      }
    };

    const fetchCategories = async () => {
      try {
        const response = await axios.post(BASEURL, {
          query: `query { allCategories }`,
        });
        const categoriesList = response?.data?.data?.allCategories || [];
        const options = categoriesList.map((cat) => ({
          value: cat,
          label: cat,
        }));
        setCategoryOptions(options);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchEmployeeDetails();
    fetchCategories();
  }, [selectedMonth?.value, selectedYear?.value]);

  const onSalaryStructureSubmit = async () => {
    const query = `query allPayrollsWithPagination(
  $category: [String]
  $month: [Int]
  $year: [Int]
  $branch: [String]
  $page: Int
  $pageSize: Int
  $search: String
) {
  allPayrollsWithPagination(
    category: $category
    month: $month
    year: $year
    branch: $branch
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    success
    message

    data {
      id
      employee {
        id
        firstName
        lastName
        empid
        branch
        category
        dateOfJoining
        employeeType
        uanNumber
        esicNumber
        bankDetails {
          accountNumber
          ifscNumber
          cifNumber
          branchName
          bankName
        }
      }
      month
      year
      monthDays
      salaryDays
      absentDays
      mealsDays
      shiftPaiseDays
      otHours
      basicAmount
      daAmount
      mealsAmountPerDay
      otAmountPerHour
      shiftPaisa
      attendanceAmount
      busFare
      esiAmount
      pfAmount
      advanceAmount
      bonusAmount
      earnedBasic
      earnedDa
      lopAmount
      otAmount
      hraAmount
      shiftPaiseAmount
      attendanceAllowance
      mealsAmount
      grossPay
      totalAmount
      netPay
    }

    pagination {
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
}`;
    setCirleLoading(true);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            category: statedata?.category,
            month: statedata?.month,
            year: statedata?.year,
            branch: statedata?.branch,
            page: paginationModel.page + 1,
            pageSize: paginationModel.pageSize,
            search: searchText,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const data = response?.data?.data?.allPayrollsWithPagination?.data;
      setEmployeeSalaryList(data);
      const totalcount =
        response?.data?.data?.allPayrollsWithPagination?.pagination
          ?.totalCount || 0;

      setTotalCount(Number(totalcount));
    } catch (error) {
      console.error("ResponseError:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (statedata) {
      onSalaryStructureSubmit();
      setTogglePage({
        ...togglePage,
        view: true,
      });
    }
  }, [searchText, paginationModel.page, paginationModel.pageSize]);

  const payrollFields = `
      employee {
        id
        firstName
        lastName
        empid
        branch
        category
        uanNumber
        esicNumber
        bankDetails {
          accountNumber
          ifscNumber
        }
      }
      month
      year
      monthDays
      salaryDays
      absentDays
      mealsDays
      shiftPaiseDays
      otHours
      basicAmount
      daAmount
      mealsAmountPerDay
      otAmountPerHour
      shiftPaisa
      attendanceAmount
      busFare
      esiAmount
      pfAmount
      hraAmount
      advanceAmount
      bonusAmount
      earnedBasic
      earnedDa
      lopAmount
      otAmount
      shiftPaiseAmount
      attendanceAllowance
      mealsAmount
      grossPay
      totalAmount
      netPay
      isManuallyEdited
      editRemarks`;

  // Pre-run payroll
  const payrollPreRun = async () => {
    const query = `
   mutation CreatePayroll($month: Int!, $year: Int!, $category: String, $employeeId: ID, $runType: String) {
  createPayroll(month: $month, year: $year, category: $category, employeeId: $employeeId, runType: $runType) {
   	success
    message
    payrolls {
      id
      ${payrollFields}
    }
  }
}`;
    setCirleLoading(true);
    try {
      const variables = {
        month: selectedMonth?.value,
        year: selectedYear?.value,
        category: payrollRunType === "category" ? selectedCategory?.value : null,
        employeeId: payrollRunType === "employee" ? employee?.value : null,
        runType: "pre_run",
      };

      const response = await axios.post(
        BASEURL,
        { query, variables },
        { headers: { "Content-Type": "application/json" } },
      );

      if (response?.data?.data?.createPayroll.success == false) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response.data.data.createPayroll?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (response?.data?.data?.createPayroll?.payrolls?.length > 0) {
        setPreRunData(response.data.data.createPayroll.payrolls);
        setPreRunView(true);
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "No Data Found",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Error running pre-run payroll:", error.message);
    } finally {
      setCirleLoading(false);
    }
  };

  // Confirm payroll (convert pre-run to actual)
  const payrollConfirm = async () => {
    const query = `
   mutation ConfirmPayroll($month: Int!, $year: Int!, $category: String, $employeeId: ID) {
  confirmPayroll(month: $month, year: $year, category: $category, employeeId: $employeeId) {
   	success
    message
    payrolls {
      id
      ${payrollFields}
    }
  }
}`;
    setCirleLoading(true);
    try {
      const variables = {
        month: selectedMonth?.value,
        year: selectedYear?.value,
        category: payrollRunType === "category" ? selectedCategory?.value : null,
        employeeId: payrollRunType === "employee" ? employee?.value : null,
      };

      const response = await axios.post(
        BASEURL,
        { query, variables },
        { headers: { "Content-Type": "application/json" } },
      );

      if (response?.data?.data?.confirmPayroll?.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Payroll Confirmed Successfully",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/payroll");
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response?.data?.data?.confirmPayroll?.message || "Failed to confirm payroll",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Error confirming payroll:", error.message);
    } finally {
      setCirleLoading(false);
    }
  };

  // Discard pre-run payroll
  const payrollDiscard = async () => {
    const query = `
   mutation DeletePreRunPayroll($month: Int!, $year: Int!, $category: String, $employeeId: ID) {
  deletePreRunPayroll(month: $month, year: $year, category: $category, employeeId: $employeeId) {
   	success
    message
  }
}`;
    setCirleLoading(true);
    try {
      const variables = {
        month: selectedMonth?.value,
        year: selectedYear?.value,
        category: payrollRunType === "category" ? selectedCategory?.value : null,
        employeeId: payrollRunType === "employee" ? employee?.value : null,
      };

      await axios.post(
        BASEURL,
        { query, variables },
        { headers: { "Content-Type": "application/json" } },
      );

      setPreRunData([]);
      setPreRunView(false);
      Swal.fire({
        position: "center",
        icon: "info",
        title: "Pre-run payroll discarded",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("Error discarding pre-run:", error.message);
    } finally {
      setCirleLoading(false);
    }
  };

  // Phase 1: Handle pre-run row click to open edit dialog
  const handlePreRunRowClick = (params) => {
    const row = params?.row;
    if (!row) return;
    // Find the original preRunData item to get the payroll ID
    const originalItem = preRunData.find((item) => (item?.id || 0) === row?.id);
    setEditingRow({ ...row, payrollId: originalItem?.id, employeeId: originalItem?.employee?.id });
    setEditFields({
      salaryDays: row?.salaryDays?.toString() || "",
      absentDays: row?.absentDays?.toString() || "",
      mealsDays: row?.mealsDays?.toString() || "",
      shiftPaiseDays: row?.shiftPaiseDays?.toString() || "",
      otHours: row?.otHours?.toString() || "",
      editRemarks: "",
    });
    setEditDialogOpen(true);
  };

  // Phase 1: Handle edit field changes - auto-sync salary_days <-> absent_days
  const handleEditFieldChange = (field, value) => {
    const updated = { ...editFields, [field]: value };
    // Find the original row's monthDays
    const originalItem = preRunData.find((item) => (item?.id || 0) === editingRow?.id);
    const monthDays = originalItem?.monthDays || 30;

    if (field === "salaryDays" && value !== "") {
      const salDays = Math.min(Math.max(0, parseInt(value) || 0), monthDays);
      updated.salaryDays = salDays.toString();
      updated.absentDays = Math.max(0, monthDays - salDays).toString();
    } else if (field === "absentDays" && value !== "") {
      const absDays = Math.min(Math.max(0, parseInt(value) || 0), monthDays);
      updated.absentDays = absDays.toString();
      updated.salaryDays = Math.max(0, monthDays - absDays).toString();
    } else if ((field === "mealsDays" || field === "shiftPaiseDays") && value !== "") {
      const clamped = Math.min(Math.max(0, parseInt(value) || 0), monthDays);
      updated[field] = clamped.toString();
    } else if (field === "otHours" && value !== "") {
      // Strip invalid characters (negatives, letters except h/m)
      const sanitized = value.replace(/[^0-9:.\shm ]/g, "");
      // Parse hours portion and cap at monthDays * 24
      const maxOtHours = monthDays * 24;
      const hourMatch = sanitized.match(/^(\d+)/);
      if (hourMatch && parseInt(hourMatch[1]) > maxOtHours) {
        updated.otHours = maxOtHours + sanitized.slice(hourMatch[1].length);
      } else {
        updated.otHours = sanitized.slice(0, 12);
      }
    }
    setEditFields(updated);
  };

  // Phase 1: Save edited pre-run payroll
  const handleEditSave = async () => {
    if (!editingRow?.payrollId) return;
    const query = `
    mutation UpdatePreRunPayroll(
      $payrollId: ID!,
      $salaryDays: Int,
      $absentDays: Int,
      $mealsDays: Int,
      $shiftPaiseDays: Int,
      $otHours: String,
      $editRemarks: String
    ) {
      updatePreRunPayroll(
        payrollId: $payrollId,
        salaryDays: $salaryDays,
        absentDays: $absentDays,
        mealsDays: $mealsDays,
        shiftPaiseDays: $shiftPaiseDays,
        otHours: $otHours,
        editRemarks: $editRemarks
      ) {
        success
        message
        payroll {
          id
          ${payrollFields}
        }
        absentDates {
          date
          dayName
        }
        presentDates {
          date
          dayName
          checkIn
          checkOut
          totalWorkingHours
        }
        salaryDaysDiff
      }
    }`;

    setCirleLoading(true);
    try {
      const variables = {
        payrollId: editingRow.payrollId,
        salaryDays: editFields.salaryDays !== "" ? parseInt(editFields.salaryDays) : null,
        absentDays: null, // Let backend calculate from salaryDays
        mealsDays: editFields.mealsDays !== "" ? parseInt(editFields.mealsDays) : null,
        shiftPaiseDays: editFields.shiftPaiseDays !== "" ? parseInt(editFields.shiftPaiseDays) : null,
        otHours: editFields.otHours || null,
        editRemarks: editFields.editRemarks || null,
      };

      const response = await axios.post(
        BASEURL,
        { query, variables },
        { headers: { "Content-Type": "application/json" } },
      );

      const result = response?.data?.data?.updatePreRunPayroll;
      if (result?.success) {
        // Update the preRunData with the recalculated payroll
        const updatedPayroll = result.payroll;
        setPreRunData((prev) =>
          prev.map((item) =>
            item.id === updatedPayroll.id ? { ...item, ...updatedPayroll } : item
          )
        );
        setEditDialogOpen(false);

        // Phase 2: Check if regularization suggestion is needed
        const diff = result.salaryDaysDiff || 0;
        if (diff > 0 && result.absentDates?.length > 0) {
          // Salary days increased - suggest marking absent dates as present
          setSalaryDaysDiff(diff);
          setRegDates(result.absentDates);
          setRegAction("mark_present");
          setRegEmployeeId(editingRow.employeeId);
          setSelectedRegDates([]);
          setRegDialogOpen(true);
        } else if (diff < 0 && result.presentDates?.length > 0) {
          // Salary days decreased - suggest marking present dates as absent
          setSalaryDaysDiff(diff);
          setRegDates(result.presentDates);
          setRegAction("mark_absent");
          setRegEmployeeId(editingRow.employeeId);
          setSelectedRegDates([]);
          setRegDialogOpen(true);
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Payroll updated successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: result?.message || "Failed to update payroll",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Error updating pre-run payroll:", error.message);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Error updating payroll",
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  // Phase 2: Toggle date selection in regularization dialog
  const handleRegDateToggle = (dateStr) => {
    setSelectedRegDates((prev) =>
      prev.includes(dateStr)
        ? prev.filter((d) => d !== dateStr)
        : [...prev, dateStr]
    );
  };

  // Phase 2: Select/Deselect all regularization dates
  const handleRegSelectAll = () => {
    if (selectedRegDates.length === regDates.length) {
      setSelectedRegDates([]);
    } else {
      setSelectedRegDates(regDates.map((d) => d.date));
    }
  };

  // Phase 2: Submit regularization
  const handleRegularize = async () => {
    if (selectedRegDates.length === 0) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Please select at least one date",
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }

    const query = `
    mutation CreatePayrollRegularization(
      $employeeId: ID!,
      $dates: [String]!,
      $action: String!,
      $reason: String
    ) {
      createPayrollRegularization(
        employeeId: $employeeId,
        dates: $dates,
        action: $action,
        reason: $reason
      ) {
        success
        message
      }
    }`;

    setCirleLoading(true);
    try {
      const variables = {
        employeeId: regEmployeeId,
        dates: selectedRegDates,
        action: regAction,
        reason: editFields.editRemarks || "Payroll pre-run adjustment",
      };

      const response = await axios.post(
        BASEURL,
        { query, variables },
        { headers: { "Content-Type": "application/json" } },
      );

      const result = response?.data?.data?.createPayrollRegularization;
      if (result?.success) {
        setRegDialogOpen(false);
        Swal.fire({
          position: "center",
          icon: "success",
          title: result.message || "Regularization completed",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: result?.message || "Regularization failed",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("Error creating regularization:", error.message);
    } finally {
      setCirleLoading(false);
    }
  };

  // Phase 2: Skip regularization
  const handleRegSkip = () => {
    setRegDialogOpen(false);
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Payroll updated (regularization skipped)",
      showConfirmButton: false,
      timer: 2000,
    });
  };

  // handel disable function

  const checkAllFields = () => {
    if (!selectedMonth || !selectedYear) return false;
    if (payrollRunType === "category" && !selectedCategory) return false;
    if (payrollRunType === "employee" && !employee?.value) return false;
    return true;
  };

  //handel pre-run
  const handleAddPayroll = () => {
    setConfirmationDialog({
      open: true,
      title: "Pre-Run Payroll",
      message:
        "This will generate a preview of payroll calculations. You can review and confirm later. Proceed?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        payrollPreRun();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  // handle confirm payroll
  const handleConfirmPayroll = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirm Payroll",
      message:
        "This will finalize the payroll. Once confirmed, it cannot be edited. Are you sure?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        payrollConfirm();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  // handle discard pre-run
  const handleDiscardPayroll = () => {
    setConfirmationDialog({
      open: true,
      title: "Discard Pre-Run",
      message:
        "Are you sure you want to discard this pre-run payroll? All preview data will be deleted.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        payrollDiscard();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //handel cancel
  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/payroll");
  };
  const handleclose = () => {
    navigate("/payroll");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card sx={{ overflow: "visible" }}>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              padding={1}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {togglePage.view
                    ? "View Payroll"
                    : preRunView
                      ? "Pre-Run Payroll (Preview)"
                      : "Add Payroll"}
                </MaterialTypography>
                {preRunView && (
                  <MaterialTypography variant="caption" color="warning">
                    This is a preview. Please review and click "Confirm Payroll" to finalize.
                  </MaterialTypography>
                )}
              </Stack>
              {togglePage.view && (
                <ButtonGroup variant="outlined" aria-label="button group">
                  <MaterialButton
                    variant="gradient"
                    style={{ backgroundColor: "green", color: "white" }}
                    startIcon={<IosShareIcon />}
                    onClick={handleExportToExcel}
                  >
                    Export
                  </MaterialButton>
                  <MaterialButton
                    sx={{ marginLeft: "3px" }}
                    variant="gradient"
                    color="dark"
                    onClick={() =>
                      navigate("/payroll/payslip", {
                        state: {
                          // addItem: {...addItem},
                          type: "allpayslip",
                          data: employeeSalaryList[0],
                        },
                      })
                    }
                  >
                    All Payslip
                  </MaterialButton>
                </ButtonGroup>
              )}
            </Stack>
          }
        />
        <CardContent>
          {preRunView && (
            <>
              <MaterialTypography
                sx={{ mt: 1, mb: 1, color: "rgba(255, 152, 0, 0.9)" }}
                variant="h6"
                fontWeight="bold"
              >
                Pre-Run Preview — {selectedMonth?.label} {selectedYear?.value}
                {selectedCategory ? ` | ${selectedCategory?.label}` : ""}
                {employee?.value ? ` | ${employee?.label}` : ""}
              </MaterialTypography>

              <MaterialTypography variant="caption" color="text" sx={{ mb: 1, display: "block" }}>
                Click on a row to edit salary days, meals days, shift paise days, or OT hours.
              </MaterialTypography>

              <MaterialDataGrid
                rows={preRunData?.map((addItem, ind) => ({
                  id: addItem?.id || ind + 1,
                  employeeId: addItem?.employee?.empid,
                  employeeName:
                    addItem?.employee?.firstName +
                    " " +
                    (addItem?.employee?.lastName || ""),
                  accountNumber: addItem?.employee?.bankDetails?.accountNumber,
                  employeeCategory: addItem?.employee?.category,
                  esiNumber: addItem?.employee?.esicNumber,
                  pfNumber: addItem?.employee?.uanNumber,
                  monthDays: addItem?.monthDays,
                  salaryDays: addItem?.salaryDays,
                  absentDays: addItem?.absentDays,
                  basicPay: addItem?.basicAmount,
                  daAllowance: addItem?.daAmount,
                  hraAmount: addItem?.hraAmount,
                  attendanceAllowance: addItem?.attendanceAllowance,
                  mealsDays: addItem?.mealsDays,
                  shiftPaiseDays: addItem?.shiftPaiseDays,
                  otHours: addItem?.otHours,
                  earnedBasic: addItem?.earnedBasic,
                  earnedDA: addItem?.earnedDa,
                  lopAmount: addItem?.lopAmount,
                  otAmount: addItem?.otAmount,
                  shiftPaiseAmount: addItem?.shiftPaiseAmount,
                  busFare: addItem?.busFare,
                  grossPay: addItem?.grossPay,
                  esiAmount: addItem?.esiAmount,
                  pfAmount: addItem?.pfAmount,
                  totalAmount: addItem?.totalAmount,
                  advanceAmount: addItem?.advanceAmount,
                  netPay: addItem?.netPay,
                  isManuallyEdited: addItem?.isManuallyEdited,
                }))}
                columns={[
                  ...EarningListTable.columns
                    .filter((col) => col.field !== "action")
                    .map((col) =>
                      preRunData?.length <= 1
                        ? { ...col, sortable: false }
                        : col
                    ),
                ]}
                onRowClick={handlePreRunRowClick}
                localeText={{
                  noRowsLabel: (
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      spacing={1}
                    >
                      <MaterialTypography
                        variant="body2"
                        fontWeight="medium"
                        color="text"
                      >
                        No pre-run data
                      </MaterialTypography>
                    </Stack>
                  ),
                }}
                customHeight="100%"
              />
            </>
          )}
          {!togglePage.view && !preRunView && (
            <MaterialBox>
              <Grid container spacing={1}>
                <Grid size={{ xs: 12, sm: 12, lg: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Year <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="year"
                    options={yearOptions}
                    value={selectedYear}
                    onChange={(year) => setSelectedYear(year)}
                    customStyles={{ optionPadding: 20 }}
                    // isClearable
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, lg: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Month <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                    name="month"
                    options={monthOptions()}
                    value={selectedMonth}
                    onChange={(month) => setSelectedMonth(month)}
                    customStyles={{ optionPadding: 20 }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, lg: 12 }}>
                  <MaterialBox lineHeight={0} display="inline-block" mb={1}>
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Run Payroll By <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialBox>
                    <ToggleButtonGroup
                      value={payrollRunType}
                      exclusive
                      onChange={(e, val) => {
                        if (val !== null) {
                          setPayrollRunType(val);
                          setSelectedCategory(null);
                          setEmplyoee({});
                        }
                      }}
                      size="small"
                    >
                      <ToggleButton value="category" sx={{ px: 3, textTransform: "none" }}>
                        Category
                      </ToggleButton>
                      <ToggleButton value="employee" sx={{ px: 3, textTransform: "none" }}>
                        Employee
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </MaterialBox>
                </Grid>

                {payrollRunType === "category" && (
                  <Grid size={{ xs: 12, sm: 12, lg: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Category <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                      name="category"
                      options={categoryOptions}
                      value={selectedCategory}
                      onChange={(cat) => setSelectedCategory(cat)}
                      customStyles={{ optionPadding: 20 }}
                    />
                  </Grid>
                )}

                {payrollRunType === "employee" && (
                  <Grid size={{ xs: 12, sm: 12, lg: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Employee <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                      name="emplyoee"
                      options={employeeOptions}
                      value={employee}
                      onChange={(e) => setEmplyoee(e)}
                      customStyles={{ optionPadding: 20 }}
                      isClearable
                    />
                  </Grid>
                )}
              </Grid>
            </MaterialBox>
          )}
          {togglePage.view && (
            <>
              <MaterialTypography
                sx={{ mt: 3, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                variant="h5"
                fontWeight="bold"
              >
                Payroll Details
              </MaterialTypography>
            <div style={{display:"flex",justifyContent:"end"}}>

                <MaterialInput
                  label="Search"
                  placeholder="Search..."

                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  icon={{
                    direction: "right",
                    component: (
                      <Icon fontSize="small">
                        <SearchIcon />
                      </Icon>
                    ),
                  }}
                />
            </div>


              <MaterialDataGrid
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                rowCount={totalCount}
                rows={EarningListTable.rows}
                columns={EarningListTable.columns}
                localeText={{
                  noRowsLabel: (
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      spacing={1}
                    >
                      <MaterialTypography
                        variant="body2"
                        fontWeight="medium"
                        color="text"
                      >
                        No details found
                      </MaterialTypography>
                    </Stack>
                  ),
                }}
                customHeight="100%"
              />
            </>
          )}
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <>
            {togglePage.view ? (
              <MaterialButton
                sx={{ m: 2, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                onClick={handleclose}
              >
                Close
              </MaterialButton>
            ) : preRunView ? (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleDiscardPayroll}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2, marginLeft: "4px" }}
                  variant="gradient"
                  style={{ backgroundColor: "green", color: "white" }}
                  onClick={handleConfirmPayroll}
                >
                  Confirm Payroll
                </MaterialButton>
              </>
            ) : (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handlecancel}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2, marginLeft: "4px" }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddPayroll}
                >
                  Pre Run
                </MaterialButton>
              </>
            )}
          </>
        </MaterialBox>
      </Card>

      {/* Phase 1: Edit Pre-Run Payroll Dialog */}
      <Dialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Edit Pre-Run Payroll
          {editingRow && (
            <MaterialTypography variant="caption" display="block" color="text">
              {editingRow.employeeName} ({editingRow.employeeId}) | Month Days: {editingRow.monthDays}
            </MaterialTypography>
          )}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 2 }}>
            <Stack direction="row" spacing={2}>
              <Stack spacing={0.5} sx={{ flex: 1 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Salary Days
                </MaterialTypography>
                <TextField
                  type="number"
                  fullWidth
                  value={editFields.salaryDays}
                  onChange={(e) => handleEditFieldChange("salaryDays", e.target.value)}
                  inputProps={{ min: 0, max: editingRow?.monthDays || 31 }}
                  size="small"
                />
              </Stack>
              <Stack spacing={0.5} sx={{ flex: 1 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Absent Days
                </MaterialTypography>
                <TextField
                  type="number"
                  fullWidth
                  value={editFields.absentDays}
                  onChange={(e) => handleEditFieldChange("absentDays", e.target.value)}
                  inputProps={{ min: 0, max: editingRow?.monthDays || 31 }}
                  size="small"
                  disabled
                />
              </Stack>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Stack spacing={0.5} sx={{ flex: 1 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Meals Days
                </MaterialTypography>
                <TextField
                  type="number"
                  fullWidth
                  value={editFields.mealsDays}
                  onChange={(e) => handleEditFieldChange("mealsDays", e.target.value)}
                  inputProps={{ min: 0 }}
                  size="small"
                />
              </Stack>
              <Stack spacing={0.5} sx={{ flex: 1 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Shift Paise Days
                </MaterialTypography>
                <TextField
                  type="number"
                  fullWidth
                  value={editFields.shiftPaiseDays}
                  onChange={(e) => handleEditFieldChange("shiftPaiseDays", e.target.value)}
                  inputProps={{ min: 0 }}
                  size="small"
                />
              </Stack>
            </Stack>
            <Stack spacing={0.5}>
              <MaterialTypography variant="caption" fontWeight="bold">
                OT Hours (H:MM)
              </MaterialTypography>
              <TextField
                fullWidth
                value={editFields.otHours}
                onChange={(e) => handleEditFieldChange("otHours", e.target.value)}
                placeholder="e.g. 5:30"
                size="small"
              />
            </Stack>
            <Stack spacing={0.5}>
              <MaterialTypography variant="caption" fontWeight="bold">
                Edit Remarks
              </MaterialTypography>
              <TextField
                fullWidth
                multiline
                rows={2}
                value={editFields.editRemarks}
                onChange={(e) => handleEditFieldChange("editRemarks", e.target.value)}
                placeholder="Reason for editing..."
                size="small"
              />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <MaterialButton
            variant="gradient"
            color="dark"
            size="small"
            onClick={() => setEditDialogOpen(false)}
          >
            Cancel
          </MaterialButton>
          <MaterialButton
            variant="gradient"
            size="small"
            style={{ backgroundColor: "green", color: "white" }}
            onClick={handleEditSave}
          >
            Save & Recalculate
          </MaterialButton>
        </DialogActions>
      </Dialog>

      {/* Phase 2: Regularization Suggestion Dialog */}
      <Dialog
        open={regDialogOpen}
        onClose={() => setRegDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {regAction === "mark_present"
            ? "Regularization Suggestion - Mark as Present"
            : "Regularization Suggestion - Mark as Absent"}
          <MaterialTypography variant="caption" display="block" color="text">
            Salary days changed by {salaryDaysDiff > 0 ? `+${salaryDaysDiff}` : salaryDaysDiff}.
            {regAction === "mark_present"
              ? " Select absent dates to mark as present (creates attendance + regularization records)."
              : " Select present dates to mark as absent (removes attendance records)."}
          </MaterialTypography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={1} sx={{ mt: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedRegDates.length === regDates.length && regDates.length > 0}
                  indeterminate={selectedRegDates.length > 0 && selectedRegDates.length < regDates.length}
                  onChange={handleRegSelectAll}
                />
              }
              label={
                <MaterialTypography variant="body2" fontWeight="bold">
                  Select All ({regDates.length} dates)
                </MaterialTypography>
              }
            />
            {regDates.map((item) => (
              <FormControlLabel
                key={item.date}
                control={
                  <Checkbox
                    checked={selectedRegDates.includes(item.date)}
                    onChange={() => handleRegDateToggle(item.date)}
                  />
                }
                label={
                  <Stack direction="row" spacing={1} alignItems="center">
                    <MaterialTypography variant="body2">
                      {item.date} ({item.dayName})
                    </MaterialTypography>
                    {item.checkIn && (
                      <Chip
                        label={`${item.checkIn} - ${item.checkOut}`}
                        size="small"
                        variant="outlined"
                      />
                    )}
                    {item.totalWorkingHours && (
                      <Chip
                        label={`${item.totalWorkingHours} hrs`}
                        size="small"
                        color="info"
                        variant="outlined"
                      />
                    )}
                  </Stack>
                }
              />
            ))}
          </Stack>
        </DialogContent>
        <DialogActions>
          <MaterialButton
            variant="gradient"
            color="dark"
            size="small"
            onClick={handleRegSkip}
          >
            Skip
          </MaterialButton>
          <MaterialButton
            variant="gradient"
            size="small"
            style={{ backgroundColor: "green", color: "white" }}
            onClick={handleRegularize}
            disabled={selectedRegDates.length === 0}
          >
            {regAction === "mark_present"
              ? `Mark Present (${selectedRegDates.length})`
              : `Mark Absent (${selectedRegDates.length})`}
          </MaterialButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default AddPayroll;
